export const gameParamsSx = {
  mt: 'auto',
  borderRadius: 6,
  overflow: 'hidden',
  mx: 10,
  mb: 10,
};